import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { QQShare } from '@ifeng-fe/three_terminal/es/mobile/qqShare/dynamic';

const SharePanel = ({ content }) => {
    return (
        <>
            <QQShare
                content={{
                    title: content?.voteList?.overview?.shareTitle || '',
                    img: content?.voteList?.overview?.shareImg || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
                    desc: content?.voteList?.overview?.shareDesc || '',
                    url: content?.voteList?.overview?.shareUrl || window.location.href,
                    cb: () => {
                        console.log('分享成功');
                    },
                }}
            />
            <div id="ifeng_share_thumbnail" style={{ display: 'none' }}>
                {content?.voteList?.overview?.shareImg || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg'}
            </div>
            <div id="ifeng_share_title" style={{ display: 'none' }}>
                {content?.voteList?.overview?.shareTitle || ''}
            </div>
            <div id="ifeng_share_description" style={{ display: 'none' }}>
                {content?.voteList?.overview?.shareDesc || ''}
            </div>
            <div id="ifeng_share_url" style={{ display: 'none' }}>
                {content?.voteList?.overview?.shareUrl || ''}
            </div>
        </>
    );
};

SharePanel.propTypes = {
    content: PropTypes.object,
};

export default SharePanel;
